import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import { useAuthenticatedUser } from '@treams/treams-hooks';
import * as graphql from '@treams/treams-network';
import {
	Avatar,
	Heading3,
	Paragraph,
	PlainCard,
	QuillText,
	Skeleton,
	tokens,
} from '@treams/treams-ui';

export default Skeleton(
	function IncomingComplimentCard(props: { compliment: graphql.Compliment; userID: string }) {
		const viewer = useAuthenticatedUser();
		const { t } = useTranslation();
		const preview = QuillText.toPlainText(props.compliment.text);

		return (
			<PlainCard
				to={
					viewer.id === props.userID
						? `/feedback/compliments/${props.compliment.id}`
						: `/users/${props.userID}/feedback/compliments/${props.compliment.id}`
				}
			>
				<Flex alignItems="center" minWidth={0} style={{ gap: tokens.gap.group }}>
					<Avatar size={48} user={props.compliment.sender} flexGrow={0} flexShrink={0} />
					<Box flexGrow={1} flexShrink={1} minWidth={0} overflow="hidden">
						<Heading3>
							{t('feedback.compliments.card.title', {
								sender: [props.compliment.sender.firstName, props.compliment.sender.lastName].join(
									' ',
								),
							})}
						</Heading3>
						<Paragraph mt={`${tokens.gap.inline}px`}>
							{t('feedback.compliments.card.receivedAt', {
								date: moment(props.compliment.createdAt).format('LL'),
							})}
						</Paragraph>
						{preview && (
							<Paragraph
								mt={`${tokens.gap.inline}px`}
								lineClamp={1}
								fontStyle="italic"
								style={{ color: tokens.text.primary }}
							>
								{preview}
							</Paragraph>
						)}
					</Box>
				</Flex>
			</PlainCard>
		);
	},
	function IncomingComplimentCardSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Flex alignItems="center" minWidth={0} style={{ gap: tokens.gap.group }}>
					<Avatar.Skeleton size={48} flexGrow={0} flexShrink={0} />
					<Box flexGrow={1} flexShrink={1} minWidth={0}>
						<Heading3.Skeleton />
						<Paragraph.Skeleton mt={`${tokens.gap.inline}px`} lines={1} />
						<Paragraph.Skeleton mt={`${tokens.gap.inline}px`} lines={1} />
					</Box>
				</Flex>
			</PlainCard.Skeleton>
		);
	},
);
